import React, { useContext, useMemo } from "react"
import { Outlet } from "react-router-dom"
import { Layout as SharedLayout } from "@stjeans/shared-frontend/layout"
import { NavItems } from "@stjeans/shared-frontend/nav"
import AppContext from "../../AppContext.jsx"
import FooterItems from "./FooterItems.jsx"
import { UpdateAvailableMobileAction } from "./UpdateAvailable.jsx"
import ConsoleViewer from "../../components/ConsoleViewer.jsx"
import { ConsoleViewerProvider, useConsoleViewer } from "../../contexts/ConsoleViewerContext.jsx"
import AdminToolbar from "../components/AdminToolbar.jsx"
import auth from "../../db/auth.js"
import "../styles/v2-shell.css"

function getCurrentLocationName(app) {
    const loc = (app.locations ?? []).find((l) => l.id === app.locationId)
    return loc?.name ?? ""
}

const fishRoomNavEnabled =
    // @ts-ignore - Vite injects `import.meta.env` at build time
    (import.meta.env.VITE_FISH_ROOM_ENABLED ?? "").toLowerCase() === "true"

export default function Layout() {
    const { app } = useContext(AppContext)
    const isAdmin = auth.isAdmin()
    const subtitle = useMemo(() => getCurrentLocationName(app), [app])
    // @ts-ignore - Vite injects `import.meta.env` at build time
    const headerColor = import.meta.env.VITE_HEADER_COLOR
    const sideNavBg = headerColor ? `#${headerColor}` : undefined

    return (
        <div
            className="w-100"
            style={sideNavBg ? /** @type {any} */ ({ "--lodge-v2-sidenav-bg": sideNavBg }) : undefined}
        >
            <ConsoleViewerProvider>
                <V2ConsoleViewerLayer />
                {isAdmin ? <AdminToolbar /> : null}
                <SharedLayout
                    title="ST JEAN'S SPORT"
                    subtitle={subtitle}
                    useLocationSelector={false}
                    navItems={[
                        <NavItems.Orders key="orders" route="/v2/orders" />,
                        <NavItems.Manifests key="manifests" route="/v2/manifests" />,
                        <NavItems.Customers key="customers" route="/v2/customers" />,
                        <NavItems.NewOrderForm key="new-order-form" route="/v2/order-form" />,
                        ...(fishRoomNavEnabled
                            ? [
                                  <NavItems.FishRoom
                                      key="fish-room"
                                      route="/v2/fish-room"
                                  />,
                              ]
                            : []),
                    ]}
                    footerItems={[<FooterItems key="footer-items" />]}
                    mobileTopBarActions={<UpdateAvailableMobileAction />}
                >
                    <Outlet />
                </SharedLayout>
            </ConsoleViewerProvider>
        </div>
    )
}

function V2ConsoleViewerLayer() {
    const { isVisible, panelWidth, hideConsoleViewer } = useConsoleViewer()

    if (!isVisible) return null

    return (
        <>
            <div
                role="button"
                tabIndex={0}
                aria-label="Close console viewer"
                onClick={hideConsoleViewer}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        hideConsoleViewer()
                    }
                }}
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ background: "rgba(0,0,0,0.25)", zIndex: 1999 }}
            />
            <div
                className="position-fixed top-0 end-0 h-100 bg-white shadow"
                style={{ width: `${panelWidth}px`, zIndex: 2000 }}
            >
                <ConsoleViewer isVisible={isVisible} onClose={hideConsoleViewer} />
            </div>
        </>
    )
}
